<template>
  <div>
    <b-overlay :show="
                                                          !userStore.isShipsLoaded ||
                                                          !deviceStore.isAgreementLoaded ||
                                                          momentaryStore.isBusy1 ||
                                                          (momentaryStore.isBusy) ||
                                                          $store.state.routes.progress.isCalculating ||
                                                          is_catalog_preparing ||
                                                          is_items_by_route_preparing
                                                        " bg-color="white" class="mt-1" :opacity="getOverlayOpacity">
      <template #overlay>
        <div v-if="is_catalog_preparing" class="text-center">
          <b-icon icon="hourglass" font-scale="2" animation="spin" />
          <p>{{ $t('route.loadingCatalog') }}</p>
        </div>
      </template>
  
      <b-container fluid>
        <b-row class="mt-2">
          <b-col order="4" order-lg="1" :lg="getTabSize()">
            <b-tabs card v-model="tabIndexProvider" small class="compact-tabs">
              <b-tab title="Primar">
                <b-tabs v-model="tabIndexService" small class="compact-tabs">
                  <b-tab title="S-63">
                    <folio-table ref="folio-tab" @call-parent-method="aaaa" />
                  </b-tab>
                  <b-tab title="S-102">
                    <NoService />
                  </b-tab>
                  <b-tab title="Navarea">
                    <NoService />
                  </b-tab>
                </b-tabs>
              </b-tab>
            </b-tabs>
          </b-col>
  
          <b-col order="2" order-lg="2" :lg="getMapSize()">
            <b-row>
              <b-col class="text-left">
                <div class="d-flex align-items-center">
                  <div class="ship-badge">
                    <!-- <i class="fas fa-ship mr-2" /> -->
                    <span>{{ getShipName }}</span>
                  </div>
                </div>
              </b-col>
              <b-col>
                <!-- <Breadcrumbs :items="breadcrumbItems" /> -->
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <folio-map ref="folio-map" :height="map_size" />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import { eventBus } from '@/main'
import { routes_map } from '@/main'
import router from '@/router'
import { useMomentaryStore } from '@/stores/momentary'
import FolioMap from '@/views/ship-folio/FolioMap.vue'
import { useRoutesStore } from '@/stores/routes'
import { mapStores } from 'pinia'
import FolioTable from '@/views/ship-folio/FolioTable.vue'
import { myAxios, myAxiosRetry } from '@/services/myAxios'
import dayjs from 'dayjs'
import { useUserStore } from '@/stores/user'
import { useDeviceStore } from '@/stores/device'
import { loadAgreements, loadShips, prepareCatalog } from '@/helpers/api'
import NoService from "@/views/ship-folio/NoService.vue";
import { setTimeout } from 'core-js'


export default {
  components: {
    FolioMap: FolioMap,
    FolioTable: FolioTable,
    NoService: NoService
  },
  data() {
    return {
      show2D: false,
      isNeedCheckSafety: false,
      isNeedCheckSafetyWarning: false,

      showRouteNameModal: false,
      routeNameInput: '',

      pathFile: null,
      routeFile: null,
      zonesFile: null,

      selected_ship: '',
      select_ship_disabled: false,
      ships: [],

      needToRestoreSearch: false,
      preparingPassagePlan: true,

      displayContent: 'showRoute',
      map_info_text: '',
      map_info_object: '',

      windowWidth: window.innerWidth,
      mapHeight: window.innerHeight / 1.2,
      mapHeightMobile: window.innerHeight / 1.8,

      map: routes_map,

      is_catalog_preparing: false,
      is_items_by_route_preparing: false,

      fields: [
        { key: 'name', label: 'name', type: 'string', tdClass: 'small-black', thClass: 'small-gray' },
        { key: 'lat', label: 'Lat', type: 'number', tdClass: 'small-black', thClass: 'small-gray' },
        { key: 'lon', label: 'Lon', type: 'number', tdClass: 'small-black', thClass: 'small-gray' },
      ],

      show_spinner: false,
      // priceCalculating: false,
      openCellsList: false,
      selectedPeriod: { period_code: '4', period: '3' },

      cellList: '',

      agreement: null,

      selected_ecdis: null,
      checkOrder: false,
      aioLayer: null,
      activeAIOItem: null,
      isDataLoading: false, // Флаг загрузки данных AIO, Navarea
    }
  },
  mounted() {
    myAxios.get('/api/v1/manage/test')

    window.onresize = () => {
      this.windowWidth = window.innerWidth
    }

    eventBus.$off('switch-wp-tab')
    eventBus.$off('search-on-map')
    eventBus.$off('send-order-route')
    eventBus.$off('show-map-info')
    eventBus.$off('show-waypoints')
    eventBus.$off('save-nogo-zones')
    eventBus.$off('route-cleared')
    eventBus.$off('calculate-ukc')
    eventBus.$off('is-need-check-safety')
    eventBus.$off('show-calculate-time')
    eventBus.$off('switch-to-general-route')
    eventBus.$off('switch-to-wp')
    eventBus.$off('graph-diag-changed')
    eventBus.$off('clear-general-route-layers')
    eventBus.$off('draw-map-layers')
    eventBus.$off('map-drag-offset')

    loadShips().then(() => {
      loadAgreements().then(() => {
        if (this.deviceStore.isDeviceIDExist) this.selected_ship = this.deviceStore.getDeviceID
        else this.selected_ship = this.userStore.getECDISShips[0]?.value ?? ''
        this.ships = this.userStore.getECDISShips

        this.select_ship_disabled = true
        this.is_catalog_preparing = true

        // loadUKHO_Publications().then(resp => {})

        setTimeout(() => {
          prepareCatalog().then(resp => {
            this.is_catalog_preparing = false
            this.is_items_by_route_preparing = false

            let mapType = 'folio-map'
            this.$refs[mapType].init_map().then(() => {
              this.is_items_by_route_preparing = false
            })
          })
        }, 2000)
      })
    })
  },
  watch: {
    selected_ship(newVal, oldVal) {
      // routes_map.clearRoute(true, true, false)
      this.deviceStore.selectDevice(newVal)
      // routes_map.redrawRoute()
      // routes_map.boundRoute()
      // routes_map.drawLogbookState()

      this.getHistory().then(resp => {
        if (this.deviceStore.getAgreementProvider === 'Primar' || this.deviceStore.getAgreementID === '-1') {
          const historyMap = new Map()

          console.log('Folio: getHistory', resp.orders)

          resp.orders.forEach(order => {
            const date = order.createdUtc
            const status = order.status

            if (status === 'complete') {
              order.items.forEach(item => {
                const name = item.id

                const monthsToAdd = Number(item.monthCount || 0)
                const period = dayjs(date).add(monthsToAdd, 'month').format('YYYY-MM-DD')

                const existing = historyMap.get(name)
                if (!existing || dayjs(period).isAfter(dayjs(existing.expiryDate))) {
                  historyMap.set(name, { name, expiryDate: period })
                }
              })
            }
          })

          console.log('Folio: map', historyMap)
          this.deviceStore.addOrdersHistoryPrimar(Array.from(historyMap.values()))
        }
      })
    },
  },
  computed: {
    dayjs() {
      return dayjs
    },
    getShipName() {
      if (this.selected_ship === "") return "";
      const ship = this.ships.find((e) => e.value === this.selected_ship);
      return ship ? ship.text : "";
    },

    getOverlayOpacity() {
      return this.$store.state.routes.progress.isCalculating ? 0.3 : 0.9
    },

    ...mapStores(useMomentaryStore, useRoutesStore, useUserStore, useDeviceStore),

    is_mobile() {
      return this.windowWidth <= 760
    },
    map_size() {
      if (this.is_mobile) return window.innerHeight / 1.8
      else return window.innerHeight / 1.2
    }
  },
  created() {
  },
  beforeDestroy() {
  },
  methods: {
    getHistory() {
      return new Promise(resolve => {
        if (!this.deviceStore.getDeviceID) {
          resolve()
          return
        }

        if (this.deviceStore.getAgreementProvider === 'Primar' || this.deviceStore.getAgreementID === '-1') {
          let URL = "/api/v1/orders/deviceid/" + this.deviceStore.getDeviceID;
          myAxios.get(URL).then(resp => {
            resolve(resp.data);
          }).catch((error) => {
            console.log(error)
          }).finally(() => {
          })
        }
      }
      )
    },
    showFolioCell(cellName) {
      this.$refs['folio-map'].showFolioCell(cellName)
    },
    getMapSize() {
      return 8
    },
    getTabSize() {
      return 4
    },
  },
}
</script>

<style scoped>
:deep(.compact-tabs .nav-tabs) {
  border-bottom: 1px solid #d1d9e6;
  display: flex;
  flex-wrap: wrap;
  /* Changed from nowrap to wrap */
  overflow-x: visible;
  /* Changed from auto to visible */
  overflow-y: visible;
  /* Changed from hidden to visible */
  scrollbar-width: thin;
  padding: 0.15rem 0.15rem 0;
}

:deep(.compact-tabs .nav-tabs .nav-item) {
  margin-bottom: 3px;
  /* Add some bottom margin for wrapped items */
  white-space: nowrap;
  flex: 0 0 auto;
  margin-right: 1px;
}

:deep(.compact-tabs .nav-link) {
  padding: 0.3rem 0.6rem;
  font-size: 0.8rem;
  border-radius: 0.4rem 0.4rem 0 0;
  transition: all 0.2s ease;
  border: 1px solid #e9ecef;
  border-bottom: none;
  color: #5a6a85;
}

:deep(.compact-tabs .nav-link:hover:not(.active)) {
  background-color: rgba(108, 117, 125, 0.08);
  border-color: #e2e8f0;
  color: #495057;
}

:deep(.compact-tabs .nav-link.active) {
  background-color: #f8f9fa;
  background-image: linear-gradient(to bottom, #ffffff, #f8f9fa);
  border-color: #d1d9e6;
  color: #3a3f51;
  font-weight: 500;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.03);
}

:deep(.compact-tabs .tab-content) {
  border: 1px solid #d1d9e6;
  border-top: none;
  padding: 0.75rem 0.2rem;
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  background-color: #ffffff;
}

/* Hide scrollbar for Chrome/Safari */
:deep(.compact-tabs .nav-tabs::-webkit-scrollbar) {
  height: 3px;
  width: 0;
}

:deep(.compact-tabs .nav-tabs::-webkit-scrollbar-thumb) {
  background: rgba(108, 117, 125, 0.2);
  border-radius: 3px;
}

:deep(.tab-content)>.tab-pane {
  padding: 0;
}

:deep(.compact-tabs .tab-pane) {
  padding-top: 0.5rem;
}

.ship-badge {
  background: #f5f6fa;
  border-radius: 6px;
  padding: 4px 12px;
  display: flex;
  align-items: center;
  color: #000000;
  font-size: 0.9em;
  min-width: 90px;
  min-height: 35px;
  font-weight: 700;
}
</style>
